import { createReducer, on } from '@ngrx/store';
import { IntegrationApiActions, IReckonIntegrationContainerActions } from './integrated-ireckon-room.actions';
import { initialState, selectIReckonIntegrationIdFromIntegration, adapter } from './integrated-ireckon-room.state';

export const integratedIReckonRoomReducer = createReducer(
  initialState,
  on(IntegrationApiActions.iReckonIntegrationsLoaded, (state, { rooms }) => adapter.upsertMany(rooms, state)),
  on(
    IntegrationApiActions.iReckonIntegrationAdded,
    IntegrationApiActions.iReckonIntegrationUpdated,
    IntegrationApiActions.iReckonIntegrationUpdatedError,
    IntegrationApiActions.iReckonIntegrationDeletedError,
    IReckonIntegrationContainerActions.iReckonIntegrationUpdated,
    (state, { room }) => adapter.upsertOne(room, state)
  ),
  on(IReckonIntegrationContainerActions.iReckonIntegrationDeleted, (state, { room }) =>
    adapter.removeOne(selectIReckonIntegrationIdFromIntegration(room), state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectIntegratedIReckonRoomIds = selectIds;

export const selectIntegratedIReckonRoomEntities = selectEntities;

export const selectAllIntegratedIReckonRooms = selectAll;
